import { useLayoutEffect } from 'react'
import { setCommonTrackingParameters } from '../../../tracking/tracking'
import { useHeyImmoExperimentTracking } from './UseHeyImmoExperimentTracking'

export function useExperimentTracking() {
  const heyImmoTrackingParameters = useHeyImmoExperimentTracking()

  useLayoutEffect(() => {
    if (!heyImmoTrackingParameters) {
      return
    }

    setCommonTrackingParameters(heyImmoTrackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [heyImmoTrackingParameters])
}
